import {svgIconWrapper} from '../svg-icon-wrapper';

import PersonRegularSearch from './person-regular-search-icon.svg';

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
    return <PersonRegularSearch {...props} />;
}
SvgComponent.iconName = 'personRegularSearch';

export const PersonRegularSearchIcon = svgIconWrapper(SvgComponent);
